// extracted by mini-css-extract-plugin
module.exports = {"submenu":"Submenu_submenu__TwztD","main":"Submenu_main__1p-My","link-container":"Submenu_link-container__3P0Be","active-link":"Submenu_active-link__2UYaa"};